import { Icon, Typography, FlexBox, Box } from '@vp/swan'
import type { BrandPillarProps } from '../../types/brand-pillars'

// SWAN does not expose a circular variant on Box; borderRadius:50% is required
// to render a perfect circle around the icon at any size.
const CIRCULAR_ICON_BG_STYLE = { borderRadius: '50%' } as const

export const Pillar = ({ icon, heading, description, justifyContent }: BrandPillarProps) => {
  return (
    <FlexBox alignItems="flex-start" justifyContent={justifyContent} paddingTop={4}>
      <Box padding={5} style={CIRCULAR_ICON_BG_STYLE} bgc="accent">
        <Icon iconType={icon} size="standard" skin="standard" aria-hidden="true" />
      </Box>
      <FlexBox flexDirection="column" paddingLeft={5}>
        <Typography fontSkin="title-item">{heading}</Typography>
        <Typography fontSkin="body-small">{description}</Typography>
      </FlexBox>
    </FlexBox>
  )
}
